import { RootComponent } from "./components/RootComponent";
import { NotFoundComponent } from "./components/NotFoundComponent";
import { CanvasComponent } from "./components/canvas/CanvasComponent";
import { MapComponent } from "./components/map/MapComponent";
import { InventoryComponent } from "./components/inventory/InventoryComponent";
import { ActionButtonsComponent } from "./components/common/ActionButtonsComponent";
import { PopupComponent } from "./components/popups/PopupComponent";
import { RestartConfirmationComponent } from "./components/popups/RestartConfirmationComponent";
import { EscapeRestartComponent } from "./components/popups/EscapeRestartComponent";
import { AskNameComponent } from "./components/achievement/AskNameComponent";
import { KeyTheftGameComponent } from "./components/minigame/KeyTheftComponent";
import { MiniGameComponent } from "./components/minigame/MinigameComponent";
import { CaughtRestartComponent } from "./components/popups/CaughtRestartComponent";

// Expose the web components to the browser
window.customElements.define("game-root", RootComponent);
window.customElements.define("game-notfound", NotFoundComponent);
window.customElements.define("game-canvas", CanvasComponent);
window.customElements.define("game-map", MapComponent);
window.customElements.define("game-inventory", InventoryComponent);
window.customElements.define("game-action-buttons", ActionButtonsComponent);
window.customElements.define("game-popup", PopupComponent);
window.customElements.define("game-restart-confirmation", RestartConfirmationComponent);
customElements.define("escape-restart-confirmation", EscapeRestartComponent);
customElements.define("caught-restart-confirmation", CaughtRestartComponent);
customElements.define("ask-name-confirmation", AskNameComponent);
window.customElements.define("key-theft-game", KeyTheftGameComponent);
window.customElements.define("game-minigame", MiniGameComponent);
